<div class="modal inmodal fade in choice-recipients-modal" [class.show]="showModal">
    <div class="modal-dialog " [ngClass]="{'loading': es.spinnerShow, 'sk-loading': es.spinnerShow}">
        <div class="modal-content">
            <button *ngIf="!es.spinnerShow" type="button" class="close" (click)="hideModal()">
                <span>×</span><span class="sr-only">Close</span>
            </button>
            <div class="flex">
                <div class="left-part col-sm-3">
                    <div class="title">Email List</div>
                    <div *ngIf="filterRecipients.filters.length > 10" class="search-box">
                        <input [(ngModel)]="filterRecipients.searchBuildingTerm"
                               placeholder="Search"
                               (ngModelChange)="filterRecipients.updateFilteredResidentsList()">
                        <i class="fa fa-search" *ngIf="!filterRecipients.searchBuildingTerm"></i>
                        <i class="fa fa-times" *ngIf="filterRecipients.searchBuildingTerm" (click)="filterRecipients.searchBuildingTerm = ''"></i>
                    </div>
                    <div class="filters-box">
                        <div class="filter m-b-sm" *ngFor="let item of filterRecipients.filters | filterByPropertyPipe:filterRecipients.searchBuildingTerm : 'buildingName'; trackBy: trackByRecipientFn">
                            <div class="img-checkbox building-checkbox">
                                <input type="checkbox" [disabled]="item.disabled" id="building-{{item.buildingId}}"
                                       [class.halfchecked]="item.isHalfCheckedClass('all')"
                                       [checked]="item.isAllCheckboxChecked()"
                                       (click)="item.toggleTargetListAndCheckTargetResidents('all', 'all', $event.target.checked);">
                                <label for="building-{{item.buildingId}}">
                                    <svg-checked></svg-checked>
                                    <svg-halfchecked></svg-halfchecked>
                                </label>
                                <label class="checkbox-label" [class.active]="item.isAllInBuildingShow()">
                                    <span (click)="item.isAllInBuildingShow() ? item.unselectTargetList('all') : item.toggleTargetList('all')">
                                        {{item.buildingName}}
                                    </span>
                                    <i class="fa {{item.showDropdown ? 'fa-chevron-up' : 'fa-chevron-down'}}"
                                       (click)="item.showDropdown = !item.showDropdown; $event.preventDefault();">
                                    </i>
                                </label>
                            </div>

                            <div class="filter-dropdown" *ngIf="item.showDropdown">
                                <div class="clearfix">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-residents"
                                                   [checked]="item.tenantsChecked && item.ownerOnChecked"
                                                   [class.halfchecked]="item.isHalfCheckedClass('residents')"
                                                   (click)="item.toggleTargetListAndCheckTargetResidents('residents', 'residents', $event.target.checked);">
                                            <label for="b-{{item.buildingId}}-residents">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label"
                                                   [class.active]="item.tenantsShow && item.ownerOnShow"
                                                   (click)="item.tenantsShow && item.ownerOnShow ? item.unselectTargetList('residents') : item.toggleTargetList('residents')">
                                                Residents
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8 pl-for-residents">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-tenants"
                                                   [class.halfchecked]="item.isHalfCheckedClass('rent')"
                                                   [(ngModel)]="item.tenantsChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('tenantsShow', 'rent', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-tenants">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.tenantsShow"
                                                   (click)="item.tenantsShow ? item.unselectTargetList('tenantsShow') : item.toggleTargetList('tenantsShow')">
                                                Tenants
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('rent') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8 pl-for-residents">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-owner-on"
                                                   [class.halfchecked]="item.isHalfCheckedClass('owner_on')"
                                                   [(ngModel)]="item.ownerOnChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('ownerOnShow', 'owner_on', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-owner-on">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.ownerOnShow"
                                                   (click)="item.ownerOnShow ? item.unselectTargetList('ownerOnShow') : item.toggleTargetList('ownerOnShow')">
                                                Owners (On-Site)
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('owner_on') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-owner-off"
                                                   [class.halfchecked]="item.isHalfCheckedClass('owner_off')"
                                                   [(ngModel)]="item.ownerOffChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('ownerOffShow', 'owner_off', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-owner-off">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.ownerOffShow"
                                                   (click)="item.ownerOffShow ? item.unselectTargetList('ownerOffShow') : item.toggleTargetList('ownerOffShow')">
                                                Owners (Off-Site)
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('owner_off') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-resident-owner"
                                                   [class.halfchecked]="item.isHalfCheckedClass('resident_owner')"
                                                   [(ngModel)]="item.residentOwnerChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('residentOwnerShow', 'resident_owner', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-resident-owner">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.residentOwnerShow"
                                                   (click)="item.residentOwnerShow ? item.unselectTargetList('residentOwnerShow') : item.toggleTargetList('residentOwnerShow')">
                                                Resident Owner
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('resident_owner') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8 padding-right-none">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-resident-only-not-on-deed"
                                                   [class.halfchecked]="item.isHalfCheckedClass('resident_only_not_on_deed')"
                                                   [(ngModel)]="item.residentOnlyNotOnDeedChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('residentOnlyNotOnDeedShow', 'resident_only_not_on_deed', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-resident-only-not-on-deed">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.residentOnlyNotOnDeedShow"
                                                   (click)="item.residentOnlyNotOnDeedShow ? item.unselectTargetList('residentOnlyNotOnDeedShow') : item.toggleTargetList('residentOnlyNotOnDeedShow')">
                                                Resident Only Not On Deed
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('resident_only_not_on_deed') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-owner-family"
                                                   [class.halfchecked]="item.isHalfCheckedClass('owner_family')"
                                                   [(ngModel)]="item.ownerFamilyChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('ownerFamilyShow', 'owner_family', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-owner-family">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.ownerFamilyShow"
                                                   (click)="item.ownerFamilyShow ? item.unselectTargetList('ownerFamilyShow') : item.toggleTargetList('ownerFamilyShow')">
                                                Owner Family
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('owner_family') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-guest"
                                                   [class.halfchecked]="item.isHalfCheckedClass('guest')"
                                                   [(ngModel)]="item.guestChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('guestShow', 'guest', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-guest">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.guestShow"
                                                   (click)="item.guestShow ? item.unselectTargetList('guestShow') : item.toggleTargetList('guestShow')">
                                                Guest
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('guest') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-offsite-resident"
                                                   [class.halfchecked]="item.isHalfCheckedClass('offsite_resident')"
                                                   [(ngModel)]="item.offsiteResidentChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('offsiteResidentShow', 'offsite_resident', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-offsite-resident">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.offsiteResidentShow"
                                                   (click)="item.offsiteResidentShow ? item.unselectTargetList('offsiteResidentShow') : item.toggleTargetList('offsiteResidentShow')">
                                                Offsite Resident
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('offsite_resident') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-resident"
                                                   [class.halfchecked]="item.isHalfCheckedClass('resident')"
                                                   [(ngModel)]="item.residentChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('residentShow', 'resident', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-resident">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.residentShow"
                                                   (click)="item.residentShow ? item.unselectTargetList('residentShow') : item.toggleTargetList('residentShow')">
                                                Resident
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('resident') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-occupant"
                                                   [class.halfchecked]="item.isHalfCheckedClass('occupant')"
                                                   [(ngModel)]="item.occupantChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('occupantShow', 'occupant', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-occupant">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.occupantShow"
                                                   (click)="item.occupantShow ? item.unselectTargetList('occupantShow') : item.toggleTargetList('occupantShow')"
                                            >Occupant</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('occupant') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-not-set"
                                                   [class.halfchecked]="item.isHalfCheckedClass('unknown')"
                                                   [(ngModel)]="item.notSetChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('notSetShow', 'unknown', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-not-set">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.notSetShow"
                                                   (click)="item.notSetShow ? item.unselectTargetList('notSetShow') : item.toggleTargetList('notSetShow')"
                                            >Not Set</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('unknown') }}</span>
                                    </div>
                                </div>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-unit-manager"
                                                   [class.halfchecked]="item.isHalfCheckedClass('unit_manager')"
                                                   [(ngModel)]="item.unitManagerChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('unitManagerShow', 'unit_manager', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-unit-manager">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.unitManagerShow"
                                                   (click)="item.unitManagerShow ? item.unselectTargetList('unitManagerShow') : item.toggleTargetList('unitManagerShow')"
                                            >Unit Manager</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('unit_manager') }}</span>
                                    </div>
                                </div>
                                
                                <hr>

                                <div class="clearfix filter__item" *ngFor="let group of item.groups; let i_g = index;">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-group-{{i_g}}"
                                                   [class.halfchecked]="item.isHalfCheckedClass('group', group.name)"
                                                   [(ngModel)]="group.checked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('group', 'group', $event.target.checked, group.name)">
                                            <label for="b-{{item.buildingId}}-group-{{i_g}}">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="group.show"
                                                   (click)="group.show ? item.unselectTargetList('group', group.name) : item.toggleTargetList('group', group.name)">
                                                {{group.name}}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUserInGroupCount(group.name) }}</span>
                                    </div>
                                </div>

                                <hr>

                                <div class="clearfix filter__item">
                                    <div class="col-sm-8">
                                        <div class="img-checkbox">
                                            <input type="checkbox" [disabled]="item.disabled" id="b-{{item.buildingId}}-staff"
                                                   [class.halfchecked]="item.isHalfCheckedClass('staff')"
                                                   [(ngModel)]="item.staffChecked"
                                                   (change)="item.toggleTargetListAndCheckTargetResidents('staffShow', 'staff', $event.target.checked)">
                                            <label for="b-{{item.buildingId}}-staff">
                                                <svg-checked></svg-checked>
                                                <svg-halfchecked></svg-halfchecked>
                                            </label>
                                            <label class="checkbox-label" [class.active]="item.staffShow"
                                                   (click)="item.staffShow ? item.unselectTargetList('staffShow') : item.toggleTargetList('staffShow')">
                                                Staff
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 text-right">
                                        <span>{{ item.getTotalUsersCount('staff') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-part col-sm-9">
                    <div class="head">
                        <div class="search-box" [ngClass]="{'hide-filter': filterRecipients.showSelected}">
                            <input [(ngModel)]="filterRecipients.searchResidentTerm"
                                   placeholder="Search"
                                   (ngModelChange)="filterRecipients.updateFilteredResidentsList()">
                            <i class="fa fa-search" *ngIf="!filterRecipients.searchResidentTerm"></i>
                            <i class="fa fa-times" *ngIf="filterRecipients.searchResidentTerm"
                               (click)="filterRecipients.searchResidentTerm = ''"></i>
                            <i class="fa fa-question mtv-primary-color" aria-hidden="true"
                               (click)="es.showSearchInstructionsModal = true;"></i>
                        </div>
                        <recipients-filter [ngClass]="{'hide-filter': filterRecipients.showSelected}"></recipients-filter>
                        <div class="box-with-checkbox">
                            <label class="img-checkbox show-selected__label" *ngIf="filterRecipients.selectedCount() > 0">
                                <input type="checkbox"
                                       id="show-selected"
                                       [(ngModel)]="filterRecipients.showSelected"
                                       (ngModelChange)="filterRecipients.updateFilteredResidentsList()">
                                <label for="show-selected">
                                    <svg-checked></svg-checked>
                                    <span>Show selected  ({{filterRecipients.selectedCount()}})</span>
                                </label>
                            </label>
                            <div class="clickable-text mtv-primary-color"
                                 *ngIf="filterRecipients.selectedCount() > 0"
                                 (click)="filterRecipients.uncheckAllResidents()">
                                Clear selected
                            </div>
                        </div>
                    </div>
                    <div class="table-box">
                        <table class="table table-striped table-hover footable" *ngIf="filterRecipients.filteredResidents.length">
                            <thead>
                            <tr [ngClass]="{'noSort': filterRecipients.filteredResidents.length < 2}">
                                <th>
                                    <div class="img-checkbox"
                                         (click)="filterRecipients.toggleCheckedAll(); filterRecipients.updateCheckboxState()">
                                        <input type="checkbox" id="selected-all" [checked]="filterRecipients.isCheckedAll()">
                                        <label for="selected-all" (click)="$event.preventDefault();">
                                            <svg-checked></svg-checked>
                                            <svg-halfchecked></svg-halfchecked>
                                        </label>
                                    </div>
                                </th>
                                <th (click)="orderBy('suiteNumber', $event)" class="footable-sorted">Unit<span class="footable-sort-indicator"></span></th>
                                <th (click)="orderBy('buildingName', $event)">Building<span class="footable-sort-indicator"></span></th>
                                <th (click)="orderBy('fullName', $event)">Recipient<span class="footable-sort-indicator"></span></th>
                                <th (click)="orderBy('role', $event)">Type<span class="footable-sort-indicator"></span></th>
                                <th>Email</th>
                                <th *ngIf="showEmailWaiverSettingsCheckbox()">e-Consent</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let item of filterRecipients.filteredResidents; trackBy: trackByResidentFn"
                                (click)="item.checked = !item.checked; filterRecipients.updateCheckboxState()">
                                <td>
                                    <div class="img-checkbox">
                                        <input type="checkbox" id="resident-{{item.id}}" [checked]="item.checked">
                                        <label for="resident-{{item.id}}" (click)="$event.preventDefault();">
                                            <svg-checked></svg-checked>
                                            <svg-halfchecked></svg-halfchecked>
                                        </label>
                                    </div>
                                </td>
                                <td>{{item.suiteNumber || '-' }}</td>
                                <td>{{item.buildingName}}</td>
                                <td>{{item.fullName}}</td>
                                <td>
                                    <span *ngIf="item.role=='owner_off'">Owner Off-Site</span>
                                    <span *ngIf="item.role=='owner_on'">Owner On-Site</span>
                                    <span *ngIf="item.role=='rent'">Tenant</span>
                                    <span *ngIf="item.role=='unknown'">Not Set</span>
                                    <span *ngIf="item.role=='resident_owner'">Resident Owner</span>
                                    <span *ngIf="item.role=='resident_only_not_on_deed'">Resident Only Not On Deed</span>
                                    <span *ngIf="item.role=='owner_family'">Owner Family</span>
                                    <span *ngIf="item.role=='guest'">Guest</span>
                                    <span *ngIf="item.role=='offsite_resident'">Offsite Resident</span>
                                    <span *ngIf="item.role=='resident'">Resident</span>
                                    <span *ngIf="item.role=='occupant'">Occupant</span>
                                    <span *ngIf="item.role=='unit_manager'">Unit Manager</span>
                                    <span *ngIf="item.role=='staff'">Staff</span>
                                </td>
                                <td>{{item.email}}</td>
                                <td *ngIf="showEmailWaiverSettingsCheckbox()" class="text-center">
                                    <i class="label-icon mtv-primary-color fa fa-check"
                                       aria-hidden="true"
                                       title="e-Consent is signed"
                                       *ngIf="item.emailWaiverSigned">
                                    </i>

                                    <i class="label-icon fa fa-times"
                                       aria-hidden="true"
                                       title="e-Consent is not signed"
                                       *ngIf="!item.emailWaiverSigned">
                                    </i>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="foot">
                <div class="reports-select-container"
                     [ngStyle]="{'opacity' : filterRecipients && filterRecipients.filteredResidents.length > 0 ? '1' : '0'}">
                    <div class="img-checkbox m-r-lg">
                        <input type="checkbox"
                               id="select-by-report"
                               #selectByReport
                               name="select-by-report"
                               (change)="onSelectByReportChange($event)">
                        <label for="select-by-report">
                            <svg-checked></svg-checked>
                            <svg-halfchecked></svg-halfchecked>
                            <span>Select recipients by Report</span>
                        </label>
                    </div>
                    <div style="width: calc(100% - 200px); position: relative;" *ngIf="selectByReport.checked && filterRecipients && filterRecipients.filteredResidents.length > 0">
                        <ng-select *ngIf="!showReportsSpinner"
                                   [items]="reports"
                                   bindLabel="name"
                                   bindValue="id"
                                   placeholder="Reports"
                                   (change)="selectRecipientsByReport($event)"
                                   class="mcc">
                        </ng-select>
                        <spinner style="width: 100%; background: #ff0000;" [spinnerShow]="showReportsSpinner"></spinner>
                    </div>
                </div>
                <button class="btn btn-primary m-l-xl" [disabled]="!filterRecipients.isSomeChecked()" (click)="saveRecipients()">
                    Save
                </button>
            </div>
        </div>

        <spinner [spinnerShow]="es.spinnerShow"></spinner>
        <search-instructions-modal *ngIf="es.showSearchInstructionsModal"></search-instructions-modal>
    </div>
    <div class="modal-backdrop fade in" (click)="!es.spinnerShow && hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/email/choice-recipients-modal/choice-recipients-modal.component.html